import React from "react";


import Dashboard from "../Pages/Dashboard";

const DashboardStudent = () => {
  return (
    <Dashboard />
  );
};

export default DashboardStudent;
